import React, { useState, useCallback, useMemo } from "react";
import {
  Background,
  Controls,
  addEdge,
  Handle,
  Position,
  applyNodeChanges
} from "reactflow";
import ReactFlow from "reactflow";
import "reactflow/dist/style.css";


// 🔵 Nodo editable
function EditableNode({ data, id }) {
  return (
    <div style={{ textAlign: "center" }}>
      <Handle type="target" position={Position.Top} />
      <input
        value={data.label}
        onChange={(e) => data.onChange(id, e.target.value)}
        style={{
          padding: "10px",
          borderRadius: "10px",
          border: "none",
          background: "#0A1F44",
          color: "#fff",
          width: "120px",
          textAlign: "center",
          outline: "none",
          boxShadow: "0 0 10px rgba(79,195,247,0.5)",
        }}
      />
      <Handle type="source" position={Position.Bottom} />
    </div>
  );
}

// Definir nodeTypes fuera del componente para evitar warning
const nodeTypes = {
  editable: EditableNode,
};

export default function Home({ onLogout }) {
  const [nodes, setNodes] = useState([
    {
      id: "1",
      type: "editable",
      data: { label: "Mi mente 🧠" },
      position: { x: 250, y: 100 },
    },
  ]);

  const [edges, setEdges] = useState([]);

  // 🔥 actualizar texto
  const updateNode = (id, value) => {
    setNodes((nds) =>
      nds.map((node) =>
        node.id === id
          ? {
              ...node,
              data: { ...node.data, label: value, onChange: updateNode },
            }
          : node
      )
    );
  };

  const onNodesChange = useCallback((changes) => {
  setNodes((nds) => applyNodeChanges(changes, nds));
}, []);

  // 🔥 conectar nodos manualmente
  const onConnect = useCallback((params) => {
    setEdges((eds) => addEdge(params, eds));
  }, []);

  // 🔥 agregar nodo manual
  const addNode = () => {
    const newId = (nodes.length + 1).toString();

    const newNode = {
      id: newId,
      type: "editable",
      data: { label: "Nueva idea", onChange: updateNode },
      position: {
        x: Math.random() * 400,
        y: Math.random() * 400,
      },
    };

    const newEdge = {
      id: `e1-${newId}`,
      source: "1",
      target: newId,
    };

    setNodes((nds) => [...nds, newNode]);
    setEdges((eds) => [...eds, newEdge]);
  };

  // 🔥 doble click = crear nodo
  const onPaneClick = (event) => {
    if (event.detail === 2) {
      const newId = (nodes.length + 1).toString();

      const newNode = {
        id: newId,
        type: "editable",
        data: { label: "Idea rápida", onChange: updateNode },
        position: {
          x: event.clientX - 100,
          y: event.clientY - 100,
        },
      };

      setNodes((nds) => [...nds, newNode]);
    }
  };



  return (
    <div style={styles.container}>
      {/* HEADER */}
      <div style={styles.header}>
        <div style={styles.headerRow}>
          <img src="/logo.svg" alt="logo" style={styles.logo} />
          <span style={styles.titleCentered}>WhatBlue</span>
          <span style={{ width: 40 }}></span>
        </div>
        <div style={styles.headerRow}>
          <span style={styles.state}>Estado: Calma</span>
          <button style={styles.logout} onClick={onLogout}>
            Logout
          </button>
        </div>
      </div>

      {/* BOTONES */}
      <div style={styles.actions}>
        <button style={styles.button} onClick={addNode}>
          + Nodo
        </button>
        <button style={styles.button} onClick={() => {
          const now = new Date();
          const dateStr = now.toLocaleString();
          const key = `whatblue-map-${now.getTime()}`;
          const mapData = {
            nodes,
            edges,
            date: dateStr
          };
          localStorage.setItem(key, JSON.stringify(mapData));
          alert(`¡Mapa guardado! (${dateStr})`);
        }}>
          Guardar
        </button>
        <button style={styles.button} onClick={() => {
          // Buscar todas las claves de mapas guardados
          const maps = [];
          for (let i = 0; i < localStorage.length; i++) {
            const k = localStorage.key(i);
            if (k && k.startsWith("whatblue-map-")) {
              const data = JSON.parse(localStorage.getItem(k));
              maps.push({ key: k, date: data.date || k.replace("whatblue-map-", "") });
            }
          }
          if (maps.length === 0) {
            alert("No hay mapas guardados.");
            return;
          }
          // Mostrar popup para elegir
          const options = maps
            .map((m, idx) => `${idx + 1}: ${m.date}`)
            .join("\n");
          const choice = prompt(`Elige el número de mapa a cargar:\n${options}`);
          const idx = parseInt(choice, 10) - 1;
          if (!isNaN(idx) && maps[idx]) {
            const mapData = JSON.parse(localStorage.getItem(maps[idx].key));
            setNodes(mapData.nodes || []);
            setEdges(mapData.edges || []);
            alert(`¡Mapa cargado! (${maps[idx].date})`);
          } else {
            alert("Selección inválida.");
          }
        }}>
          Cargar
        </button>
      </div>

      {/* MAPA */}
      <div style={styles.map}>
        <ReactFlow
          nodes={nodes.map((n) => ({
            ...n,
            data: { ...n.data, onChange: updateNode },
          }))}
          edges={edges}
          nodeTypes={nodeTypes}
          onConnect={onConnect}
          onNodesChange={onNodesChange}
          onPaneClick={onPaneClick}
          fitView
        >
          <Background color="#4FC3F7" gap={20} />
          <Controls />
        </ReactFlow>
      </div>
    </div>
  );
}

const styles = {
  logo: {
    width: "40px",
    height: "40px",
    marginRight: "12px",
  },
  header: {
    padding: "15px",
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    background: "none",
  },
  headerRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    gap: "10px",
  },
  title: {
    fontWeight: "bold",
    fontSize: "2rem",
    color: "#fff",
    marginRight: "12px",
    letterSpacing: 1,
  },
  container: {
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    background: "linear-gradient(135deg, #0A1F44, #000814)",
    color: "#fff",
  },
  state: {
    color: "#4FC3F7",
    marginRight: "15px",
  },
  logout: {
    padding: "5px 10px",
    background: "#ff5252",
    border: "none",
    borderRadius: "5px",
    color: "#fff",
    cursor: "pointer",
  },
  actions: {
    padding: "10px",
    display: "flex",
    gap: "12px",
  },
  button: {
    padding: "10px 15px",
    background: "#4FC3F7",
    border: "none",
    borderRadius: "10px",
    cursor: "pointer",
    fontWeight: "bold",
  },
  map: {
    flex: 1,
    minHeight: 0,
  },
  headerRight: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
};